import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from 'store/configureStore';
import './assets/styles/global.css';
import './assets/styles/overrides.css';
import './i18n';

const validThemes = [
  'mainTheme',
  'contrastBloom',
  'firstTheme',
  'secondTheme',
  'fifthTheme',
  'seventhTheme',
  'eighthTheme',
  'ninethTheeme',
  'lilacTheme',
];
const savedTheme = localStorage.getItem('theme');
if (savedTheme && !validThemes.includes(savedTheme)) {
  localStorage.setItem('theme', 'mainTheme');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);

reportWebVitals();
